const UserPush = {
  computed: {
    granted() {
      return (
        Notification.permission === 'granted' &&
        (this.user.pushes || []).length > 0
      );
    },
    ...Vuex.mapState(['user']),
  },
  methods: {
    activate() {
      registerPushNotifications().then((result) => {
        if (result) {
          this.user.pushes = ['granted'];
        }
      });
    },
    deactivate() {
      axios.delete('/usuarios/suscribirse').then((r) => {
        customAlert(
          'Enhorabuena',
          'Ya has desactivado las notificaciones push.',
        );
        this.user.pushes = [];
        brownies.local.pushAgain = new Date().getTime() + 168 * 3600 * 1000;
      });
    },
  },
  template: `
      <div class="user-push-form">
        <div v-if="granted">
          <p>Estás recibiendo notificaciones push.</p>
          <button class="uk-button uk-button-dmtk" @click="deactivate">
            Desactivar notificaciones
          </button>
        </div>
        <div v-else>
          <p>¿Quieres recibir notificaciones push?</p>
          <button class="uk-button uk-button-dmtk" @click="activate">
            Activar notificaciones
          </button>
        </div>
      </div>
	`,
};
